/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The alert level expected to be sent to Slack Client.
 * @export
 */
export type SlackAlertLevel =
  | SlackAlertLevelInfo
  | SlackAlertLevelError
  | SlackAlertLevelWarning
  | SlackAlertLevelSuccess;

/**
 * The alert level info type.
 * @export
 */
export type SlackAlertLevelInfo = typeof SLACK_ALERT_LEVEL_INFO;

/**
 * The alert level error type.
 * @export
 */
export type SlackAlertLevelError = typeof SLACK_ALERT_LEVEL_ERROR;

/**
 * The alert level warning type.
 * @export
 */
export type SlackAlertLevelWarning = typeof SLACK_ALERT_LEVEL_WARNING;

/**
 * The alert level success type.
 * @export
 */
export type SlackAlertLevelSuccess = typeof SLACK_ALERT_LEVEL_SUCCESS;

/**
 * The alert level info constant.
 * @export
 */
export const SLACK_ALERT_LEVEL_INFO = `INFO`;

/**
 * The alert level error constant.
 * @export
 */
export const SLACK_ALERT_LEVEL_ERROR = `ERROR`;

/**
 * The alert level warning constant.
 * @export
 */
export const SLACK_ALERT_LEVEL_WARNING = `WARNING`;

/**
 * The alert level success constant.
 * @export
 */
export const SLACK_ALERT_LEVEL_SUCCESS = `SUCCESS`;

/**
 * The request body expected to be sent to Slack Client.
 * @export
 */
export type SlackAlertRequestBody = {
  text: string;
};
